import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import TextArea from './textarea';
import { MESSAGE_TYPE, setMessageInput, showOptions } from '../../actions';
import { APISubmode } from '../../../../../api/types';
import SendActiveIcon from '../../../../../common/icons/mojorange/send-active.svg';
import SendUnactiveIcon from '../../../../../common/icons/mojorange/send-unactive.svg';
import ClipIcon from '../../../../../common/icons/clip.svg';
import EmojiIcon from '../../../../../common/icons/emoji.svg';
import { validate } from '../../../../../../common/validation';
import processUserInput from './processUserInput';
import './style.scss';

class ChatInput extends Component {
    constructor(props) {
        super(props);

        // this.genesys = props.genesys;
        this.API = props.API;

        this.textChangeTimeout = null;

        // React ES6 does not bind 'this' to event handlers by default
        this.submitHandler = this.submitHandler.bind(this);
        this.textChangeHandler = this.textChangeHandler.bind(this);
        this.onShowEmoji = this.onShowEmoji.bind(this);
        this.onUploadFile = this.onUploadFile.bind(this);
        this.appendText = this.appendText.bind(this);

        this.state = {
            isTextValid: this.props.inputMask ? false : true
        };

        if (this.props.callbacks) {
            this.props.callbacks({
                appendText: this.appendText
            });
        }

        this.fileInput = createRef(null);
        this.textArea = createRef(null);
    }

    submitHandler(event) {
        // Stop the form from refreshing the page on submit
        event.preventDefault();

        if (this.props.inputMask && !this.state.isTextValid) {
            const key = event.charCode || event.keyCode || 0;
            if (key === 13) {
                return;
            }
        }

        const processedInput = processUserInput(this.props.messageInput, this.props.chat.submode);
        // Call the onSend callback with the chatInput message
        this.props.onSend(processedInput);

        const { dispatch } = this.props;
        dispatch(setMessageInput(''));
        this.setState({ isTextValid: false });

        if (this.textChangeTimeout) {
            clearTimeout(this.textChangeTimeout);
        }
    }

    validateText(text) {
        if (this.props.inputMask) {
            const masks = this.props.inputMask.split('|');

            let isValueValid = false;
            let isTextValid = false;
            masks.forEach((m) => {
                const validation = validate(m, text);
                isValueValid = isValueValid || validation.isValueValid;
                isTextValid = isTextValid || (validation.isLengthValid && validation.isValueValid);
            });

            // this.setState({ isTextValid: isTextValid });
            return { isValueValid, isTextValid };
        }
        return { isValueValid: true, isTextValid: true };
    }

    textChangeHandler(event) {
        const el = event.target;

        // const isTextValid = this.validateText(el.value);

        const validation = this.validateText(el.value);

        if (validation.isValueValid) {
            const { dispatch } = this.props;
            dispatch(setMessageInput(el.value));
            this.setState({ isTextValid: validation.isTextValid });
        }

        if (this.textChangeTimeout) {
            clearTimeout(this.textChangeTimeout);
        }

        this.textChangeTimeout = setTimeout(() => {
            this.API.sendTyping(el.value);
        }, 10);
    }

    appendText(message) {
        this.appendText(message);
    }

    onShowEmoji(e) {
        e.preventDefault();

        const { dispatch } = this.props;
        dispatch(showOptions(this.props.chat.options ? null : 'emoji'));
    }

    hasAcceptedExtension(name) {
        name = name.toLowerCase();
        const extpos = name.lastIndexOf('.');
        const ext = name.substring(extpos);
        return this.props.storageAccept.split(',').indexOf(ext) !== -1;
    }

    onUploadFile(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];
            const accepted = this.hasAcceptedExtension(file.name);
            this.API.Helper.uploadFile(file, !accepted);
        }

        // hack to clear input[file] selected files
        e.target.type = '';
        e.target.type = 'file';
    }

    render() {
        const formLeftActions = (
            <div className="opl-widget-chat--form-actions left">
                {this.props.storageOptions &&
                    this.props.storageOptions.storageAvailable &&
                    !this.props.storageDisabled &&
                    this.props.storageNeedAgent &&
                    this.props.chat.submode !== APISubmode.MAX && [
                        <button
                            key="filebutton"
                            className="opl-widget-chat--attachment button"
                            disabled={this.props.disabled || this.props.storageDisabled}
                            onClick={() => {
                                this.fileInput.current.click();
                            }}
                        >
                            <ClipIcon />
                        </button>,
                        <input
                            key="fileinput"
                            ref={this.fileInput}
                            style={{ display: 'none' }}
                            type="file"
                            id="file-drop"
                            disabled={this.props.disabled || this.props.storageDisabled}
                            multiple={true}
                            accept={this.props.storageAccept}
                            data-max-size={this.props.storageMaxSize}
                            onChange={this.onUploadFile}
                            name="files[]"
                        />
                    ]}
            </div>
        );

        const sendDisabled = this.props.disabled || this.props.messageInput.length === 0;

        const formRightActions = (
            <div className="opl-widget-chat--form-actions right">
                {!this.props.inputMask && (
                    <button
                        className="opl-widget-chat--emoji-picker"
                        disabled={this.props.disabled}
                        onClick={this.onShowEmoji}
                    >
                        <EmojiIcon />
                    </button>
                )}
                <button
                    className="opl-widget-chat--send"
                    disabled={sendDisabled || !this.state.isTextValid}
                    onClick={this.submitHandler}
                >
                    {sendDisabled || !this.state.isTextValid ? (
                        <SendUnactiveIcon />
                    ) : (
                        <SendActiveIcon />
                    )}
                </button>
            </div>
        );

        return (
            <div className="opl-widget-chat--input-container">
                {formLeftActions}
                <form className="opl-widget-chat--form" onSubmit={this.submitHandler}>
                    <TextArea
                        // ref={(el) => (this.textArea = el)}
                        onChange={this.textChangeHandler}
                        onSubmit={this.submitHandler}
                        className="opl-widget-chat--input scroll"
                        style={{ lineHeight: '20px' }}
                        value={this.props.messageInput}
                        placeholder="Wpisz treść i naciśnij ENTER"
                        rows="1"
                        maxRows="4"
                        disabled={this.props.disabled}
                        autosize
                        required
                        callbacks={(callbacks) => {
                            this.appendText = callbacks.appendText;
                            this.textArea = callbacks.textArea;
                        }}
                        maxLength={
                            this.props.chat.submode === APISubmode.MAX
                                ? this.props.maxMessageLengthForMAX || null
                                : this.props.maxMessageLengthForAgent || null
                        }
                        currentLength={this.props.totalMessageLength}
                    />
                </form>
                {formRightActions}
            </div>
        );
    }
}

const isStorageLimitsExceeded = (limits) => {
    const maxFiles = parseInt(limits['upload-max-files']);
    const maxTotalSize = parseInt(limits['upload-max-total-size']);
    const usedFiles = parseInt(limits['used-upload-max-files']);
    const usedTotalSize = parseInt(limits['used-upload-max-total-size']);
    return usedFiles >= maxFiles || usedTotalSize >= maxTotalSize;
};

const getTotalMessageLength = (messages) => {
    var total = 0;
    for (var i = messages.length; i--; i > 0) {
        var message = messages[i];
        if (message.type === MESSAGE_TYPE.MESSAGE && message.from === 'client') {
            total += message.message.length;
        } else {
            break;
        }
    }
    return total;
};

const mapStateToProps = (state) => {
    return {
        chat: state.chat,
        messageInput: state.chat.messageInput || '',
        inputMask: state.chat.inputMask,
        chatOptions: state.config.widget.chatOptions,
        storageOptions: state.config.widget.chatOptions.storageOptions || {
            storageAvailable: false
        },
        totalMessageLength: getTotalMessageLength(state.chat.messages),
        storageAccept: state.chat.fileLimits['upload-file-types']
            .split(':')
            .map((ext) => {
                ext = ext.trim();
                ext = ext.indexOf('/') !== -1 ? ext : `.${ext}`;
                if (
                    state.config.widget.chatOptions.storageOptions &&
                    typeof state.config.widget.chatOptions.storageOptions.storageAccept === 'string'
                ) {
                    const sa = state.config.widget.chatOptions.storageOptions.storageAccept
                        .split(':')
                        .map((ext) => {
                            ext = ext.trim();
                            return ext.indexOf('/') !== -1 ? ext : `.${ext}`;
                        });
                    if (!sa.includes(ext)) {
                        return null;
                    }
                }
                return ext;
            })
            .filter((e) => e != null)
            .join(','),
        storageMaxSize: parseInt(state.chat.fileLimits['upload-max-file-size']),
        storageDisabled: isStorageLimitsExceeded(state.chat.fileLimits),
        storageNeedAgent:
            state.chat.fileLimits['upload-need-agent'] === 'false'
                ? true
                : state.chat.agent.available,
        theme:
            state.settings.widget && state.settings.widget.theme
                ? state.settings.widget.theme.split(' ')
                : ['default'],
        maxMessageLengthForMAX: state.settings.chatOptions?.maxMessageLengthForMAX,
        maxMessageLengthForAgent: state.settings.chatOptions?.maxMessageLengthForAgent
    };
};

export default connect(mapStateToProps)(ChatInput);
